import React from 'react';

// Generic icon for tool badges
const ToolIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

// Generic icon for generating response
const SparkleIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" stroke="currentColor" strokeWidth="2"/>
    </svg>
);

const AgentActions = ({ actions }) => {
    if (!actions || actions.length === 0) return null;

    // Separate tool actions and general actions
    const toolActions = actions.filter(a => a['toolName']);
    const generalActions = actions.filter(a => !a['toolName']);

    // Get unique tools (keep latest status for each tool)
    const uniqueToolActions = [];
    const seenTools = new Set();
    for (let i = toolActions.length - 1; i >= 0; i--) {
        const action = toolActions[i];
        if (!seenTools.has(action['toolName'])) {
            seenTools.add(action['toolName']);
            uniqueToolActions.unshift(action);
        }
    }

    return (
        <div className="clarence-agent-actions">
            <div className="agent-actions-header">
                <div className="pulse-dot"></div>
                <span>Clarence is working...</span>
            </div>

            {/* Show tools being used - labels come from backend */}
            {uniqueToolActions.length > 0 && (
                <div className="agent-tools-used">
                    <span className="tools-label">Using tools:</span>
                    <div className="tools-badges">
                        {uniqueToolActions.map((action, idx) => {
                            const isComplete = action['status'] === 'completed';
                            return (
                                <span key={idx} className={`tool-badge ${isComplete ? 'completed' : 'active'}`}>
                                    <ToolIcon />
                                    {action['toolDisplayName'] || action['toolName']}
                                    {isComplete && (
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" className="tool-check">
                                            <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </span>
                            );
                        })}
                    </div>
                </div>
            )}

            <ul className="agent-actions-list">
                {generalActions.map((action, idx) => {
                    const isComplete = action['status'] === 'completed';
                    const isFailed = action['status'] === 'failed';

                    return (
                        <li key={idx} className={`agent-action-item ${action['status']}`}>
                            <span className="action-icon">
                                <SparkleIcon />
                            </span>
                            <span className="action-label">{action['description'] || 'Processing...'}</span>
                            {!isComplete && !isFailed && <span className="action-spinner"></span>}
                            {isComplete && (
                                <span className="action-check">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </span>
                            )}
                            {isFailed && (
                                <span className="action-error">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                </span>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AgentActions;
